import React, { useEffect, useRef } from 'react'

interface PopupProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
  className?: string
  width?: string
  position?: 'top' | 'bottom' | 'left' | 'right'
  align?: 'start' | 'center' | 'end'
  offset?: string
  zIndex?: string
}

const Popup = ({
  isOpen,
  onClose,
  children,
  className = '',
  width = 'w-full',
  position = 'bottom',
  align = 'start',
  offset = 'mt-3',
  zIndex = 'z-50'
}: PopupProps) => {
  const popupRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  const getPositionClasses = () => {
    const positionClasses = {
      top: 'bottom-full left-0',
      bottom: 'top-full left-0',
      left: 'right-full top-0',
      right: 'left-full top-0'
    }

    const alignClasses = {
      start: '',
      center:
        position === 'top' || position === 'bottom'
          ? 'left-1/2 transform -translate-x-1/2'
          : 'top-1/2 transform -translate-y-1/2',
      end: position === 'top' || position === 'bottom' ? 'right-0' : 'bottom-0'
    }

    return `${positionClasses[position]} ${alignClasses[align]}`
  }

  return (
    <div
      ref={popupRef}
      className={`absolute ${getPositionClasses()} ${offset} overflow-hidden rounded-2xl border border-ink-100/15 bg-white-500 shadow-[0_24px_56px_-24px_rgba(18,38,63,0.22),0_4px_12px_-4px_rgba(18,38,63,0.06)] ${zIndex} ${width} ${className}`}
    >
      {children}
    </div>
  )
}

export default Popup
